import {
  ActionsFacturaBodyTemplate,
  CIFBodyTemplate,
  ClienteBodyTemplate,
  EstadosBodyTemplate,
  FechaBodyTemplate,
  ImporteBodyTemplate,
  NumFacturaBodyTemplate,
  NumeroArchivosAdjuntosTemplate,
  TipoEstadoMultiselectBodyTemplate,
} from "features/Documentos/templates"
import { nanoid } from "nanoid"
import { ESTADO_COLUMN } from "."

import { ESTADO_REVISION_DOCUMENTO_FILTERS } from "../../../common/utils/constants"

export const facturasColumns = (
  // @ts-expect-error TS(6133): 'tabSelected' is declared but its value is never r...
  tabSelected: $TSMigrationFixMe,
  t: $TSMigrationFixMe
) => [
  {
    key: nanoid(),
    header: `${t("crear.factura.tab.headerNumOrder")}`,
    sortable: true,
    body: NumFacturaBodyTemplate,
    filter: false,
    field: "numero",
    customFilter: {
      type: "input",
      name: "SerieNumero",
    },
  },
  {
    key: nanoid(),
    header: `${t("crear.factura.tab.headerCompanyName")}`,
    sortable: true,
    filter: false,
    body: ClienteBodyTemplate,
    field: "Librado.RazonSocial",
    customFilter: {
      type: "input",
      name: "RazonSocialLibrado",
    },
  },
  {
    key: nanoid(),
    header: `${t("crear.factura.tab.headerNif")}`,
    sortable: true,
    filter: false,
    body: CIFBodyTemplate,
    field: "Librado.Nif",
    customFilter: {
      type: "input",
      name: "NifLIbrado",
    },
  },
  {
    key: nanoid(),
    header: `${t("crear.factura.tab.headerImport")}`,
    sortable: true,
    body: ImporteBodyTemplate,
    field: "importe",
  },
  {
    key: ESTADO_COLUMN,
    header: `${t("crear.factura.tab.headerState")}`,
    sortable: true,
    body: (rowData: $TSMigrationFixMe) => EstadosBodyTemplate(rowData, t),
    field: "estadoRevisionActual",
    headerStyle: {
      width: 150,
    },
    filter: false,
    customFilter: {
      type: "select",
      options: ESTADO_REVISION_DOCUMENTO_FILTERS(t),
      name: "estadoRevision",
      placeholder: "Tipo de Estado",
      itemTemplate: TipoEstadoMultiselectBodyTemplate,
    },
  },
  {
    key: nanoid(),
    header: `${t("crear.factura.tab.headerEmisionDate")}`,
    sortable: true,
    filter: false,
    body: FechaBodyTemplate,
    field: "fechaEmision",
    customFilter: {
      type: "date",
      name: "fechaEmision",
    },
  },
  {
    key: nanoid(),
    header: `${t("crear.factura.tab.headerAdjArc")}`,
    body: NumeroArchivosAdjuntosTemplate,
    isFunctionComponent: true,
    headerStyle: {
      width: 80,
    },
  },
  {
    key: nanoid(),
    body: ActionsFacturaBodyTemplate,
    isFunctionComponent: true,
    headerStyle: {
      width: 80,
    },
  },
]
